// v1mv6HY4hoM
// UCSiDGb0MnHFGjs4E2WKvShw

import {useState, useEffect} from 'react';
import CardLoadingSkeletion from './CardLoadingSkeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactLoading from "react-loading";
import ChannelHome from '../videoGrid2';
import fetchApi2 from '../FetchData'
import { useParams } from "react-router-dom";


const ChannelDetails = ()=>{

    let { id } = useParams();
    const [active, setActive] = useState('Home');
    const [channelVedioArr, setChannelVedioArr] = useState([])
    const [Loading, setLoading] = useState(true)
    const [page, setPage] = useState(1);
    const [channelDetails,setChannelDetails] = useState(null);
    const [showMore,setShowMore] = useState(false);

    const menuItems = ['Home', 'Videos', 'Playlist', 'Live'];
    const [hasMore, setHasMore] = useState(true);
    const [suscribeButtonText,setSuscribeButtonText] = useState('suscribe');

    const addToSuscribe = ()=>{

      if(suscribeButtonText === 'Suscribed')
      {
        removeFromSuscribe();
      }
      else{

        let tempData = {
          id:channelDetails.id,
          img:channelDetails.snippet.thumbnails.high.url,         
          channelName: channelDetails.snippet.title
        }

        let data = JSON.parse(localStorage.getItem("userDetails"));
        data['subscription'].push(tempData);
        setSuscribeButtonText('Suscribed');
        localStorage.setItem("userDetails", JSON.stringify(data));
      }
    }
      
    const removeFromSuscribe = ()=>{
      let data = JSON.parse(localStorage.getItem("userDetails"));
     
      let index =  data['subscription'].findIndex(element => channelDetails.id === element.id);

      // let index = data['subscription'].indexOf(channelDetails.id); // Find the index of the element


      data['subscription'].splice(index, 1); 
      setSuscribeButtonText('Suscribe');
      localStorage.setItem("userDetails", JSON.stringify(data));
    }
    const fetchChannelVideos = ()=>{
        setLoading(true)
        // setDatabaseDataLength(0);
        
        
            
        
            try {
    
    
                fetchApi2(`search?channelId=${id}&part=snippet%2Cid&order=date&maxResults=50`, '')
                    .then((videos) => {
        
                
                    
                
                            let vidData = videos.items;
                            
                            
                            setChannelVedioArr(vidData);
                
                    
            
                      setLoading(false)
                    })
        
                
           
            }
            catch (e) {
              
            }
          
        return true;
    }
    const loadMoreItems = () => {


        
        setHasMore(false)
        // setting Related Videos
        fetchApi2(`search?channelId=${id}&part=snippet%2Cid&order=date&maxResults=50&page=${page}`, "")
          .then((response) => {
            setPage(page+1);
            setChannelVedioArr((pre) => [...channelVedioArr, ...response?.items])
            setHasMore(true)
            
            return true
          })
    
    
    
        //   setTimeout(()=>{
        //     setItems(prevItems => [...prevItems, 0, 3, 5, 3, 42, 32, 2]);
    
        //   },1500)
      };
      
      function formatDate(dateString) {
        const months = [
          'January', 'February', 'March', 'April', 'May', 'June', 
          'July', 'August', 'September', 'October', 'November', 'December'
        ];
      
       
        const date = new Date(dateString);
      
  
        const day = date.getUTCDate();
        const month = months[date.getUTCMonth()];
        const year = date.getUTCFullYear();
      
        // Return the formatted date string
        return `${day} ${month} ${year}`;
      }

      function addBreakFunc(text) {

        // return text;
        
        let data = text ? text.length === 0 ? text : text.split('\n').map((line, index) => <div key={index}>{line}</div>) : " ";
        return data;
        // let pattern = /^https:\/\//;
    
        //   // Iterate through the strings
        //   for (let i = 0; i < text.length; i++) {
        //       // Check if the string starts with "https://"
        //       if (pattern.test(text[i])) {
        //           // Add "\n" after the match
        //           text[i] += "\n";
        //       }
        //   }
        
      }
      function ShortNumber(number) {
        if (number >= 1000000) {
          return (number / 1000000).toFixed(1) + "M";
        } else if (number >= 1000) {
          return (number / 1000).toFixed(1) + "k";
        } else {
          return number;
        }
      }
    
    
  useEffect(() => {

    
    // setLoading(true)
    // setDatabaseDataLength(0);
    
      
        try {



            
            fetchApi2(`channels?part=snippet%2Cstatistics&id=${id}`, '')
            .then((details) => {


        

                // let vidData = videos.items;
                
                
                setChannelDetails(details.items[0]);

                        
              let userData = JSON.parse(localStorage.getItem("userDetails"));
              let index =  userData['subscription'].findIndex(element => details.items[0].id === element.id); 
              if(index > -1)
              {
                setSuscribeButtonText('Suscribed');
              }
          
    
    
            })
        }
        catch (e) {
          
        }
      
    

  }, [])

    return (
        <section>
            <div className="main py-4 sm:px-8 bg-black w-full h-full sm:min-h-[90vh] ">
            <div className="banner bg-blue-600 w-[78.5vw] text-center mx-auto rounded-md overflow-hidden">
                <img className="w-full h-[10.5rem] object-cover object-center" src={`${channelDetails?.brandingSettings.image.bannerExternalUrl}`}  alt=""/>
            </div>


            {/* // details */}
                <div className="details flex flex-col sm:flex-row justify-center items-center sm:justify-start text-white h-56 mt-4 w-[78.5vw] mx-auto space-x-4">
                    <div className='img py-3 px-2 mx-2 h-40'>
                        <img className=" h-40 w-40 rounded-full" src={`${channelDetails?.snippet.thumbnails.high.url}`} alt=""  />
                    </div>
                    <div className="flex flex-col justify-center sm:justify-between py-3">
                        <h1 className="text-4xl font-bold font-serif">{channelDetails?.snippet.title}</h1>
                        <div className="text-gray-500 flex space-x-1">
                            <p className='hover:text-red-500 hidden sm:block'>{channelDetails?.snippet.customUrl}</p> <br className="w-1 h-1 rounded-full text-white" />
                            <p className='hover:text-red-500'>{ShortNumber(channelDetails?.statistics.subscriberCount)
} suscribers</p> <br />
                            <p className='hover:text-red-500 hidden sm:block'>{channelDetails?.statistics.videoCount} vedios</p> <br />
                        </div>

                        <div className="text-center sm:text-start sm:my-2">
                        <button type="button" onClick={()=>addToSuscribe()} class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900">{suscribeButtonText}</button>
                        </div>
                    </div>
                    

                </div>

                <nav className="text-white  overflow-hidden p-4 sm:w-[40%] ml-28 mt-16 sm:mt-0">
                    <ul className="flex sm:justify-around">
                        {menuItems.map((item) => (
                        <li 
                            key={item} 
                            className={`${(item === 'Playlist') || (item === 'Live') ? 'none' : ''} cursor-pointer hover:border-b-2 hover:border-gray-500  hover:text-red-300 px-4 font-bold font-sans pb-4 transition duration-300 ease-in-out ${active === item ? 'border-b-2 border-red-500 text-red-500' : 'hover:text-red-500 '}`} 
                            onClick={() => { if(item==='Videos'){fetchChannelVideos();} setActive(item)}}
                        >
                            {item}
                        </li>
                        ))}
                    </ul>
                    </nav>
             
                <div className="bg-white h-[1px]"></div>



              { active === 'Home' &&  <section className='text-white mt-3 overflow-x-auto '>
                    <div className=" text-center flex flex-col space-y-4 shadow-lg shadow-white">
                      <h1 className='text-6xl font-bold mt-4 hover:text-red-500'>{channelDetails?.snippet.title}</h1>  
                      <p className="font-semibold text-gray-500 hover:text-gray-300">Total Number of Suscribers : {ShortNumber(channelDetails?.statistics.subscriberCount)}</p>
                      <p className="font-semibold text-gray-500 hover:text-gray-300">Total Number of Vedios : {channelDetails?.statistics.videoCount}+</p>
                      <p className="font-semibold text-gray-500 hover:text-gray-300">Channel was created at {formatDate(channelDetails?.snippet.
publishedAt)
}</p>

                      <div>

                      {channelDetails && <div id="desc" className={`bg-gray-800 shadow-md shadow-white rounded-md m-2 w-[60%] p-2 text-sm mx-auto ${(showMore) ? "h-fit" : " h-6 sm:h-24 overflow-hidden"}`}>

                            {addBreakFunc(channelDetails?.snippet.
description)}
                        </div>}
                        {channelDetails && <div>
                            <button className="ml-2 text-sm font-semibold px-1 hover:bg-gray-500" onClick={() => setShowMore(!showMore)}>{(showMore) ? "show less" : "show more..."}</button>

                        </div>}
                      </div>





                    </div>
                </section>}


               { active === "Videos" &&  <div className="videos h-fit w-[87vw] my-2 mx-auto border-2 border-white ">
                        <div className="">
                        {Loading ? <div className={` w-full grid grid-cols-1 gap-x-2 gap-y-8  lg:${"grid-cols-4"} text-white`}>
                        <CardLoadingSkeletion></CardLoadingSkeletion>
                        <CardLoadingSkeletion></CardLoadingSkeletion>
                        <CardLoadingSkeletion></CardLoadingSkeletion>
                        <CardLoadingSkeletion></CardLoadingSkeletion>
                        <CardLoadingSkeletion></CardLoadingSkeletion>
                        <CardLoadingSkeletion></CardLoadingSkeletion>

                        <CardLoadingSkeletion></CardLoadingSkeletion>
                        <CardLoadingSkeletion></CardLoadingSkeletion>


                        </div>
                        :
                       
                        <div className=''>
                            <InfiniteScroll
                            className={'bg-gray-700 p-1'}
                            dataLength={channelVedioArr?.length}
                            next={channelVedioArr?.length > 0 && loadMoreItems} // Function to call when scrolling to the bottom
                            hasMore={hasMore} // Indicates whether more items can be loaded
                            loader={<div className=' bg-black'>
                            <ReactLoading className="mx-auto" type={'balls'} color={'white'} height={'5%'} width={'5%'} />
                            </div>} // Loader component to display while loading
                            endMessage={<p>No more items to be loaded</p>} // Message displayed when all items are loaded

                            
                            >
                            
                        
                            <ChannelHome  vedios={channelVedioArr}  />
                            
                            </InfiniteScroll>

                        </div>
                        }
                    </div>
                </div>}
            </div>
        </section>
    )
}

export default ChannelDetails;